import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#80C4FF"
      d="M12.293 4.293a1 1 0 0 1 1.414 0L16 6.585l2.293-2.292a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 0 1.414L17 8.414v5.854l5.067-2.927.992-3.7a1 1 0 0 1 1.932.518l-.842 3.134 3.135.841a1 1 0 0 1 .73 1.11l-.023.115a1 1 0 0 1-1.225.707l-3.7-.993L18 16l5.067 2.927 3.7-.993a1 1 0 0 1 .518 1.932l-3.135.84.842 3.135a1 1 0 0 1-.596 1.188l-.11.037a1 1 0 0 1-1.226-.707l-.992-3.7L17 17.733v5.853l2.707 2.707a1 1 0 0 1-1.414 1.414L16 25.415l-2.293 2.292a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1 0-1.414L15 23.586v-5.854L9.933 20.66l-.992 3.7a1 1 0 0 1-1.932-.518l.84-3.135-3.133-.84a1 1 0 0 1-.73-1.11l.023-.115a1 1 0 0 1 1.225-.707l3.7.993L14 16l-5.067-2.927-3.7.993a1 1 0 0 1-.518-1.932l3.134-.841-.841-3.134a1 1 0 0 1 .596-1.188l.11-.037a1 1 0 0 1 1.226.707l.992 3.7L15 14.268V8.414l-2.707-2.707a1 1 0 0 1 0-1.414"
    />
  </svg>
);
const SvgIconWeatherSnowflake = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWeatherSnowflake);
export default Memo;
